import { Component, inject } from '@angular/core';
import { Order, OrderStatus } from '../../../models/new/order';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'bt-orders-modal',
	standalone: false,
	templateUrl: './orders-modal.component.html',
	styleUrl: './orders-modal.component.scss'
})
export class OrdersModalComponent {
	readonly dialogRef = inject(MatDialogRef<OrdersModalComponent>);
	readonly data = inject(MAT_DIALOG_DATA);
	orderStatus = OrderStatus;

	orders: Order[] = [];

	constructor() {
		this.orders = this.data.orders;
		console.log(this.orders);
	}

	close() {
		this.dialogRef.close(null);
	}
}
